
/* eslint-disable vue/no-mutating-props, no-param-reassign */
import { defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import InputText from 'primevue/inputtext';
import SimpleColorPicker from '@/components/fields/SimpleColorPicker.vue';
import RcsVisualImageField from '@/components/rcs-onboarding/RcsVisualImageField.vue';
import {
  RCS_VISUAL_LABEL_MAX_LENGTH,
  RCS_VISUAL_TAGLINE_MAX_LENGTH,
  normalizeRcsPhoneNumber,
} from '@/types/rcs-onboarding';
import type { RcsDedicatedFormState } from '@/types/rcs-onboarding';

export default defineComponent({
  name: 'VisualDesignStep',

  components: {
    InputText,
    SimpleColorPicker,
    RcsVisualImageField,
  },

  props: {
    form: {
      type: Object as PropType<RcsDedicatedFormState>,
      required: true,
    },
  },

  setup(props) {
    const { t } = useI18n();

    const onBrandColorChanged = (color: string) => {
      props.form.visual.brand_color = color;
    };

    const normalizePhoneInput = () => {
      props.form.visual.phone.number = normalizeRcsPhoneNumber(
        props.form.visual.phone.number,
      );
    };

    const addWebsite = () => {
      props.form.visual.website.push({ address: '', label: '' });
    };

    const removeWebsite = (index: number) => {
      props.form.visual.website.splice(index, 1);
    };

    return {
      t,
      taglineMaxLength: RCS_VISUAL_TAGLINE_MAX_LENGTH,
      labelMaxLength: RCS_VISUAL_LABEL_MAX_LENGTH,
      onBrandColorChanged,
      normalizePhoneInput,
      addWebsite,
      removeWebsite,
    };
  },
});
